import { render, staticRenderFns } from "./ApproveModelRiskForm.vue?vue&type=template&id=123d593d&scoped=true&"
import script from "./ApproveModelRiskForm.vue?vue&type=script&lang=js&"
export * from "./ApproveModelRiskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d593d",
  null
  
)

export default component.exports